<template>
  <div class="modal fade create-new-client-modal" id="CreateClientModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar cliente</h1>
                  <button type="button" class="btn-close create-new-client-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateClient" @submit.prevent="createClientMethod">
                <div class="modal-body ps-30 pe-30">










                  <div class="row">
                    <div class="col-xxl-12">
                      <div
                        class="card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing radius-7"
                      >
                        <div class="card-body">
                          <ul
                            class="nav nav-tabs bg-white border-0 rounded-0 radius-7"
                            id="myTab"
                            role="tablist"
                          >

                            <li class="nav-item" role="presentation">
                              <button
                                class="nav-link fs-14 fs-md-15 fs-lg-16 fw-bold position-relative border-0 rounded-0 d-block w-100 active radius-7"
                                id="payment-method-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#payment-method-tab-pane"
                                type="button"
                                role="tab"
                                aria-controls="payment-method-tab-pane"
                                aria-selected="true"
                              >
                                <i class="flaticon-edit"></i>
                                Criar manualmente
                              </button>
                            </li>

                            <li class="nav-item" role="presentation">
                              <button
                                class="nav-link fs-14 fs-md-15 fs-lg-16 fw-bold position-relative border-0 rounded-0 d-block w-100 radius-7"
                                id="place-order-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#place-order-tab-pane"
                                type="button"
                                role="tab"
                                aria-controls="place-order-tab-pane"
                                aria-selected="false"
                              >
                                <i class="flaticon-zip-file"></i>
                                Criar via csv
                              </button>
                            </li>
                          </ul>

                          <div id="myTabContent" class="tab-content p-15 p-sm-20 p-md-25 p-lg-30">
                            <div
                              class="tab-pane fade show active"
                              id="payment-method-tab-pane"
                              role="tabpanel"
                              tabindex="0"
                            >

                              <p>Preencha as informações abaixo para criar um cliente</p>
                              <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                                <label for="name_client_created" class="form-label fw-medium"
                                  >Nome</label
                                >
                                <input
                                  type="text"
                                  class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                                  id="name_client_created"
                                  placeholder="Digite o nome"
                                  autocomplete="off"
                                  required
                                />
                              </div>
                              
                              <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                                <label for="email_client_created" class="form-label fw-medium"
                                  >Email (opcional)</label
                                >
                                <input
                                  type="email"
                                  class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                                  id="email_client_created"
                                  placeholder="Digite o email"
                                  autocomplete="off"
                                />
                              </div>

                              <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                                <label for="cellphone_client_created" class="form-label fw-medium"
                                  >Celular</label
                                >                      
                                  <input
                                  id="cellphone_client_created"
                                  ref="cellphone"
                                  type="text"
                                  name="cellphone"
                                  class="form-control shadow-none rounded-0 text-black radius-7"
                                  placeholder="Digite o celular"
                                  @keyup="changeInformationInputs('cellphone')"
                                  @input="applyMaskPhone"
                                  maxlength="15"
                                />
                              </div>

                              <!-- nascimento opcional -->
                              <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                                <label for="birthdate_client_created" class="form-label fw-medium"
                                  >Data de nascimento (opcional)</label
                                >
                                <input
                                  id="birthdate_client_created"
                                  type="text"
                                  class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                                  placeholder="Digite a data ex: DD/MM/AAAA"
                                  autocomplete="off"
                                  maxlength="10"
                                  @input="applyMaskDate"
                                />
                              </div>

                              <div class="col-12">
                                <div id="alertResponseApiCreateClient" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                                  <div class="d-flex">
                                    <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateClient">
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="custom-footer">
                                <button type="button" class="btn btn-danger create-new-client-modal" data-bs-dismiss="modal">Cancelar</button>
                                <button type="submit" ref="buttonCreateClient" class="btn btn-success">Criar cliente</button>
                              </div>
                            </div>



                            <div
                              class="tab-pane fade"
                              id="place-order-tab-pane"
                              role="tabpanel"
                              tabindex="0"
                            >
                            









                            <div class="alert alert-info d-flex align-items-center fs-md-15 fs-lg-16 alert-csv-example top-custom" role="alert">
                              <i class="flaticon-telegram lh-1 fs-15 position-relative top-1 me-8"></i>
                              Importe um arquivo CSV para criar automaticamente.
                              <a href="/csv_exemplo.csv" download class="ms-1 fw-semibold text-decoration-underline">
                                (Baixar CSV de exemplo)
                              </a>
                            </div>

                            <div class="d-flex flex-column align-items-center bottom-custom">
                              <label for="formFile" class="form-label fw-medium">Selecione um arquivo csv:</label>
                              <input 
                                type="file" 
                                id="fileInput" 
                                ref="csvFile"
                                class="d-none" 
                                @change="onFileChange"
                                accept=".csv"
                              >

                              <label for="fileInput" class="custom-file-upload">
                                {{ fileName || "Clique para selecionar um arquivo..." }}
                              </label>

                            </div>

                            <div class="custom-footer">
                              <button type="button" class="btn btn-danger create-new-client-modal" data-bs-dismiss="modal">Cancelar</button>
                              <button type="button" ref="buttonCreateClientByCsv" @click="sendCsvClients()" class="btn btn-success">Criar clientes</button>
                            </div>







                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>











                  
                  
                </div>

              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';

export default {
  name: "CreateClientModal",
  data () {
    return {
      selectedFile: null,
      fileName: null,
    }
  },
  methods: {
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    applyMaskDate(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '').slice(0, 8);

      if (value.length > 2) {
        value = `${value.slice(0, 2)}/${value.slice(2)}`;
      }
      if (value.length > 5) {
        value = `${value.slice(0, 5)}/${value.slice(5)}`;
      }

      input.value = value;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.selectedFile = file;
      this.fileName = file ? file.name : null;
    },
    sendCsvClients(){
      const params = new FormData();
      params.append("csv_file", this.selectedFile);

      api.axios.post("api/create/clients/csv", params, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).catch(function(error){
        console.log("erro ao enviar csv", error);
      }).then(function(response){
        if(response != undefined && response.status == 200){
          window.location.reload();
        }
      });
    },
    createClientMethod(){
      const alertResponse = this.alertResponse;

      const name_client_created = document.getElementById("name_client_created").value;
      const email_client_created = document.getElementById("email_client_created").value;
      const cellphone_client_created = document.getElementById("cellphone_client_created").value;
      let error = false;

      if(
        name_client_created == "" ||
        cellphone_client_created == ""
      ){
        this.alertResponse("Por favor preencha todos os campos obrigatórios", true);
        return;
      }

      if(name_client_created == ""){
        document.getElementById("name_client_created").style.borderColor = "red";
        error = true;
      }

      if(error){
        return;
      }

      const objClientCreate = {
        "name": name_client_created,
        "email": email_client_created,
        "phone": cellphone_client_created.replace(/\D/g, ''),
      }

      const buttonCreateClient = this.$refs.buttonCreateClient;
      buttonCreateClient.disabled = true;
      buttonCreateClient.innerHTML = "Criando cliente...";
      
      // add birth date to payload if filled
      const birthdate = document.getElementById("birthdate_client_created").value;
      if (birthdate && birthdate.length < 10) {
        this.alertResponse("Data de nascimento incompleta.", true);
        buttonCreateClient.disabled = false;
        buttonCreateClient.innerHTML = "Criar cliente";
        return;
      }
      if(birthdate && birthdate.trim() !== ""){
        objClientCreate.birth_date = birthdate;
      }

      api.axios.post("/api/create/client", objClientCreate).catch(function(error){
        if(error.response.data != undefined){
          buttonCreateClient.innerHTML = "Criar cliente";
        }
        console.log("error", error);
        alertResponse(error.response.data, true);
      }).then(function(response){
        
        if(response != undefined && response.status == 200){
          buttonCreateClient.innerHTML = "Cliente criado com sucesso !";
          window.location.reload();
        } else {
          buttonCreateClient.disabled = false;
          buttonCreateClient.innerHTML = "Criar cliente";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageCreateClient").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateClient").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateClient");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }
    },
  }
};
</script>
<style scoped>

.custom-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.custom-file-upload {
    /* border: 1px solid #ccc; */
    padding: 10px 15px;
    border-radius: 6px;
    display: inline-block;
    cursor: pointer;
    background-color: #6560F0;
    color: #fff;
    width: fit-content;
    font-weight: bold;
    transition: 0.3s;
}
.custom-file-upload:hover {
    background: #474787;
}

.top-custom{
  margin-top: 50px;
}

.bottom-custom{
  margin-bottom: 50px;
}
</style>
